import { NavbarBrand } from '@typedream/components';
import { findNodePath } from '@udecode/plate-core';
import { useContext, useRef } from 'react';
import { useTPlateEditorRef } from '../../../plate';
import { NavbarMenuItemContext } from '../context/navbar.context';

export const DEFAULT_LOGO_HEIGHT = 28;

export function NavbarSelectLogoToolbar() {
  return (<div><span>Select Log..</span></div>);
}

export function NavbarBrandElementEditor() {
  const { element: navbar } = useContext(NavbarMenuItemContext);
  const editable = true;
  const editor = useTPlateEditorRef();
  const navbarPath = findNodePath(editor, navbar)!;

  const navbarBrandRef = useRef(null);
  const onClickNavbar = () => {
    editor.emitter.emit(
      'toolbar:navbar:setting-menu:toggle',
      {
        navbarPath,
        type: 'brand',
        ref: navbarBrandRef.current,
      },
    );
  };

  return (
    <NavbarBrand
      ref={navbarBrandRef}
      element={{
        // Prevent navigating away to the url
        logoURL: undefined,
        ...navbar,
      }}
      editable={editable}
      onClick={onClickNavbar}
      onClickLogo={() => {
        editor.emitter.emit('toolbar:navbar:setting-menu:toggle-logo', navbar);
      }}
    >
      {navbar.logoTitle || (
        <span>Empty Text!</span>
      )}
    </NavbarBrand>
  );
}
